import { render } from "./InspectionView.vue?vue&type=template&id=6b223340&lang=true"
import script from "./InspectionView.vue?vue&type=script&lang=js"
export * from "./InspectionView.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/0EA9C00323D8BFD1/Code/ptbcs-quasar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QBtnGroup,QBtn,QInput,QIcon,QTd,QDialog,QCard,QCardSection,QSelect,QCardActions});qInstall(script, 'directives', {ClosePopup});
